module.exports = __webpack_public_path__ + "img/norway-eye-and-ear-diseases-female.78f544d9.png";